import {TabBody} from "../../../tab-content";
import {ManagedTab} from "../../../managed-tabs";
import {ClientHierarchyHierarchyColumn} from "./ClientHierarchyHierarchyColumn";
import {useLocation} from "react-router-dom";
import {ClientHierarchyActionButtons} from "../ClientHierarchyActionButtons";

import "./ClientHierarchyHierarchyTab.scss";

export const ClientHierarchyHierarchyTab: ManagedTab = () => {
  // Prevents hierarchy column from rendering until tab is clicked on
  const location = useLocation();

  return (
    <TabBody name={"client-hierarchy-tab"}>
      <ClientHierarchyActionButtons />
      {location.hash === "#hierarchy" && <ClientHierarchyHierarchyColumn />}
    </TabBody>
  );
};
